import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';
import { ErrorHandleService } from './error-handle.service';

@Injectable({
  providedIn: 'root'
})

export class AccountEndpoint extends EndpointFactory {

  private readonly _baseUrl: string = "/api/account/getuser";

  get baseUrl() { return this.configurations.baseUrl + this._baseUrl; }

  constructor(http: HttpClient, configurations: ConfigurationService,
    errorHandleService: ErrorHandleService, injector: Injector) {

    super(http, configurations, errorHandleService, injector);
  }

  getUserEndpoint<T>(userId: string): Observable<T> {
    let endpointUrl = `${this.baseUrl}/${encodeURI(userId)}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.errorHandleService.handleError(error, () => this.getUserEndpoint(userId));
      }));
  }
}
